export enum ModuleTabEnums {
    CHILDREN = 'children',
    BOOKINGS = 'child-booking',
    GUARDIAN = 'guardian'
}

